var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentStory)?_c('StaticPage',{attrs:{"current-story":_vm.currentStory}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }